import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { comicCategories } from '@/mocks/categories';

export default function Hero() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/category?q=${encodeURIComponent(q)}` : '/category');
  };

  return (
    <section className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[600px]">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Vibrant%20pop%20art%20comic%20illustration%20background%20with%20scattered%20comic%20panels%20speech%20bubbles%20explosion%20bursts%20stars%20and%20lightning%20shapes%20in%20coral%20orange%20yellow%20and%20teal%20palette%2C%20playful%20wacky%20energetic%20humor%20mood%2C%20bold%20thick%20outlines%2C%20flat%20illustration%2C%20no%20text%2C%20wide%20horizontal%20composition&width=1600&height=700&seq=hero-ww&orientation=landscape')",
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-background-50/80" aria-hidden="true" />

      <div className="container-page relative z-10 w-full py-20 text-center md:py-24">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-100/80 px-4 py-1.5 text-sm font-bold text-primary-700">
          <i className="ri-emotion-laugh-line" aria-hidden="true" />
          每日更新 · 越看越上头
        </span>

        <h1 className="mx-auto mt-6 max-w-3xl text-4xl leading-tight text-foreground-950 md:text-6xl">
          歪歪一下，<span className="text-primary-600">笑到停不下来</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          韩国歪歪漫画恶搞反转、神展开、脑洞魔性、爆笑合集一网打尽。分类清晰，即时追更，带你进入一个
          <strong>越看越上头</strong>的快乐世界。
        </p>

        <form onSubmit={submit} className="mx-auto mt-8 flex max-w-xl items-center gap-2 rounded-full border border-background-300 bg-background-50 p-2 shadow-sm">
          <i className="ri-search-line ml-3 text-lg text-foreground-500" aria-hidden="true" />
          <input
            type="search"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜作品名 / 作者 / 标签，一秒开笑"
            className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
            aria-label="搜索漫画"
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始追更
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <span className="text-sm text-foreground-600">热门：</span>
          {comicCategories.slice(0, 5).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="whitespace-nowrap rounded-full bg-background-50/90 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:bg-accent-300 hover:text-foreground-950"
            >
              #{cat.name}
            </Link>
          ))}
        </div>

        <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/category/hot"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            看看今日神作
          </Link>
          <Link
            to="/category/reversal"
            className="whitespace-nowrap rounded-full border border-foreground-300 bg-background-50/70 px-6 py-3 text-sm font-bold text-foreground-950 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            反转剧场直通车
          </Link>
        </div>
      </div>
    </section>
  );
}